import ApiService from 'services/ApiService';

interface OfferingOfferingOptionValueModel {
        id?: number;
        offeringid: number;
        offeringoptionvalueid: number;
}

class OfferingOfferingOptionValueService extends ApiService<OfferingOfferingOptionValueModel> {
        constructor() {
                super('offeringoptionvalueoffering');
        }

        async getByOffering(offeringId: string | number): Promise<OfferingOfferingOptionValueModel[]> {
                const params = new URLSearchParams({ 
                        where: JSON.stringify({ offeringid: Number(offeringId) }),
                        limit: '0' 
                });
                return this.getAll(params);
        }
}

export default new OfferingOfferingOptionValueService();
